export const buttonTypes = {
  primary: "primary",
  transparent: "transparent",
  link: "link",
  withoutBorder: "withoutBorder",
  setting: "setting",
  bigModal: "bigModal",
};
